(function(){
'use strict';

if (document.readyState !== 'loading') { initOrSkip(); }
else { document.addEventListener('DOMContentLoaded', initOrSkip); }

function isReloadNavigation() {
  try {
    if (performance.navigation && performance.navigation.type === 1) return true;
  } catch(e) {}
  try {
    var entries = performance.getEntriesByType('navigation');
    if (entries.length && entries[0].type === 'reload') return true;
  } catch(e) {}
  return false;
}

function initOrSkip() {
  if ((window.Shopify && window.Shopify.designMode) ||
      document.documentElement.classList.contains('shopify-design-mode')) {
    killPreloader(); setupHeader(); return;
  }
  if (!document.body.classList.contains('template-index')) {
    killPreloader(); setupHeader(); return;
  }
  /* Skip preloader only when: flag exists (not first visit) AND not a reload.
     Reload always re-plays. New tab/session (sessionStorage cleared) always plays. */
  try {
    var hasPlayed = sessionStorage.getItem('c9pl') === '1';
    if (hasPlayed && !isReloadNavigation()) {
      killPreloader(); setupHeader(); return;
    }
  } catch(e) {}
  init();
}

function killPreloader() {
  document.body.classList.remove('c9-loading');
  var el = document.getElementById('c9-preloader');
  if (el) el.style.display = 'none';
}

function setupHeader() {
  if (!document.body.classList.contains('template-index')) return;
  var hw     = document.querySelector('.header-wrapper');
  var sticky = document.getElementById('c9-sticky');
  if (!hw) return;

  hw.style.transition = 'opacity 0.8s ease, background 0.35s ease, backdrop-filter 0.35s ease, box-shadow 0.35s ease';
  requestAnimationFrame(function() {
    requestAnimationFrame(function() { hw.style.opacity = '1'; });
  });

  function getHeroImgH() {
    var imgBlock = document.querySelector('.c9h2__img-block');
    if (imgBlock) return imgBlock.getBoundingClientRect().height;
    var heroEl = document.querySelector('.c9-hero');
    if (heroEl) return heroEl.getBoundingClientRect().height;
    return window.innerHeight;
  }

  function update() {
    var sy      = window.scrollY;
    var heroH   = getHeroImgH();
    var pastImg = sy >= heroH - 10;

    if (!pastImg) {
      hw.style.removeProperty('pointer-events');
      hw.classList.remove('c9-hidden');
      if (hw.style.opacity === '0') hw.style.opacity = '1';
      hw.classList.toggle('c9-scrolled', sy > 60);
    } else {
      hw.style.opacity = '0';
      hw.style.pointerEvents = 'none';
      hw.classList.add('c9-hidden');
      hw.classList.remove('c9-scrolled');
    }
    if (sticky) sticky.classList.toggle('c9-sticky--visible', pastImg);
  }
  window.addEventListener('scroll', update, { passive: true });
  if (window.scrollY > 0) update();
}

function init() {
  var $ = function(id) { return document.getElementById(id); };
  var raf = requestAnimationFrame;

  var tens    = $('c9-tens');
  var units   = $('c9-units');
  var pct     = $('c9-pct');
  var counter = $('c9-counter');
  var preload = $('c9-preloader');
  var clout   = $('c9-clout');
  var studio  = $('c9-studio');

  if (!preload) { killPreloader(); setupHeader(); return; }

  var counterShift = 0;

  if (window.innerWidth < 750) {
    var fs0 = parseFloat(window.getComputedStyle(units).fontSize);

    clout.style.fontSize  = fs0 + 'px';
    studio.style.fontSize = fs0 + 'px';

    var glyphW0 = units.getBoundingClientRect().width;
    try {
      var r0 = document.createRange();
      r0.selectNodeContents(units);
      var gr0 = r0.getBoundingClientRect();
      if (gr0.width > 0) glyphW0 = gr0.width;
    } catch(e) {}

    var space0    = fs0 * 0.20;
    var totalW0   = clout.offsetWidth + space0 + glyphW0 + space0 + studio.offsetWidth;
    var nineLeft0 = (window.innerWidth - totalW0) / 2 + clout.offsetWidth + space0;
    var curLeft0  = units.getBoundingClientRect().left;

    counterShift = nineLeft0 - curLeft0;

    counter.style.transition = 'none';
    counter.style.transform  = 'translateX(' + counterShift + 'px)';
  }

  /* PHASE 1 */
  var TOTAL = 2800, t0 = null, curVal = -1;
  function ease(t) { return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2,3)/2; }
  function tick(ts) {
    if (!t0) t0 = ts;
    var p   = Math.min((ts - t0) / TOTAL, 1);
    var val = Math.floor(ease(p) * 99);
    if (val !== curVal) {
      curVal = val;
      tens.textContent  = String(Math.floor(val / 10));
      units.textContent = String(val % 10);
    }
    if (p < 1) { raf(tick); }
    else { tens.textContent = '9'; units.textContent = '9'; setTimeout(phase2, 300); }
  }
  raf(tick);

  /* PHASE 2 */
  function phase2() {
    var rect  = units.getBoundingClientRect();
    var fs    = parseFloat(window.getComputedStyle(units).fontSize);
    var space = fs * 0.20;

    var glyphW = rect.width;
    try {
      var range = document.createRange();
      range.selectNodeContents(units);
      var gr = range.getBoundingClientRect();
      if (gr.width > 0) glyphW = gr.width;
    } catch(e) {}

    clout.style.fontSize  = fs + 'px';
    studio.style.fontSize = fs + 'px';

    var cloutW = clout.offsetWidth;

    var nineLeft  = rect.left;
    var nineRight = rect.left + glyphW;

    clout.style.top       = rect.top + 'px';
    clout.style.left      = (nineLeft - space - cloutW) + 'px';
    clout.style.opacity   = '1';
    clout.style.transform = 'translateY(110vh)';

    studio.style.top       = rect.top + 'px';
    studio.style.left      = (nineRight + space) + 'px';
    studio.style.opacity   = '1';
    studio.style.transform = 'translateY(110vh)';

    void preload.offsetWidth;

    var fade = 'opacity 0.55s ease, transform 0.55s ease';
    tens.style.transition = fade;
    pct.style.transition  = fade;
    tens.style.opacity    = '0';
    tens.style.transform  = 'translateY(-12px)';
    pct.style.opacity     = '0';
    pct.style.transform   = 'translateY(-12px)';

    var spring = 'transform 1.25s cubic-bezier(0.16,1,0.3,1)';
    clout.style.transition = spring;
    clout.style.transform  = 'translateY(0)';
    setTimeout(function() {
      studio.style.transition = spring;
      studio.style.transform  = 'translateY(0)';
    }, 55);

    setTimeout(phase3, 1800);
  }

  /* PHASE 3 */
  function phase3() {
    document.dispatchEvent(new CustomEvent('clout9:wipe'));
    preload.style.transition      = 'background-color 0.45s ease';
    preload.style.backgroundColor = 'rgba(12,12,12,0)';
    var fly = 'transform 1.0s cubic-bezier(0.76,0,0.24,1)';

    counter.style.transition = fly;
    counter.style.transform  = counterShift
      ? 'translateX(' + counterShift + 'px) translateY(-120vh)'
      : 'translateY(-120vh)';

    clout.style.transition  = fly;
    clout.style.transform   = 'translateY(-120vh)';
    studio.style.transition = fly;
    studio.style.transform  = 'translateY(-120vh)';

    setTimeout(function() {
      try { sessionStorage.setItem('c9pl', '1'); } catch(e) {}
      killPreloader();
      setupHeader();
      document.dispatchEvent(new CustomEvent('clout9:ready'));
    }, 1650);
  }
}

})();
